import { render, staticRenderFns } from "./FullOfferMarkets.vue?vue&type=template&id=532a471d&scoped=true"
import script from "./FullOfferMarkets.vue?vue&type=script&lang=js"
export * from "./FullOfferMarkets.vue?vue&type=script&lang=js"
import style0 from "./FullOfferMarkets.vue?vue&type=style&index=0&id=532a471d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532a471d",
  null
  
)

export default component.exports